import {
  Component,
  EventEmitter,
  input,
  Input,
  InputSignal,
  Output,
} from '@angular/core';
import {
  ActionButton,
  ActionButtonType,
} from '../../../../models/action-button.model';

@Component({
  selector: 'app-action-button',
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.scss'],
})
export class ActionButtonComponent {
  readonly DISABLED_SUFFIX = 'Disabled';
  readonly ActionButtonEnum = ActionButtonType;

  readonly row: InputSignal<any> = input<any>();
  readonly action: InputSignal<ActionButton> = input<ActionButton>();

  @Output()
  actionClick: EventEmitter<ActionButton> = new EventEmitter();

  emitAction(): void {
    this.action().row = this.row();
    this.actionClick.emit(this.action());
  }
}
